interface CoinsDisplayProps {
  value?: number | null;
}

const CoinsDisplay = ({ value }: CoinsDisplayProps) => {
  if (value == null) {
    return <span>—</span>;
  }

  return <span>{value.toLocaleString("en-IN")}</span>;
};

export default CoinsDisplay;
